import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postSwissportForm } from "../../redux/actions/swissportActions";

const FiveYearHistory = ({ appData, postSwissportFormFunc }) => {
  const {
    firstName = "",
    lastName = "",
    emailAddress = "",
    nationalInsuranceNo = "",
    address: { addressLine1, town, postcode, county },
  } = {
    address: { addressLine1: "", town: "", postcode: "", county: "" },
    ...appData,
  }; // in case that candidate has no address

  let initialData = {
    firstName,
    lastName,
    emailAddress,
    dateOfBirth: appData.dateOfBirth
      ? moment(appData.dateOfBirth).format("DD/MM/YYYY")
      : "",
    nationalInsuranceNo,
    addressLine1,
    postTown: town,
    postCode: postcode,
    county,
  };

  const initialWorkHistory = [
    {
      from: "",
      to: "",
      company: "",
      address: "",
      email: "",
      reason: "",
      type: "",
      operating: false,
    },
  ];

  const initialErrorMessages = [
    {
      toAfterFromDate: "",
      tooBigGap: "",
      keepOrder: "",
    },
  ];
  if (appData.swissportOnboarding) {
    initialData = {
      ...initialData,
    };
  }

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);
  const [shouldDisable, setShouldDisable] = useState(true);
  const [workHistoryData, setWorkHistoryData] = useState(initialWorkHistory);
  const [travelData, setTravelData] = useState({
    fromTravel1: "",
    toTravel1: "",
    countryVisited1: "",
    toTravel2: "",
    fromTravel2: "",
    countryVisited2: "",
  });
  const [declaration5YCH, setDeclaration] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] =
    useState(initialErrorMessages);
  const [fiveYearsErrorMessage, setFiveYearsErrorMessage] = useState("");

  useEffect(() => {
    let areAllFieldsFilled = true;
    let areErrorMessagesEmpty = true;

    const validationMessages = workHistoryData.map(() => ({}));
    // check if there are no empty values
    workHistoryData.forEach((el) => {
      if (el.type === "Gap") {
        Object.keys(el).forEach((key) => {
          if (
            key !== "company" &&
            key !== "address" &&
            key !== "reason" &&
            key !== "email" &&
            key !== "operating"
          ) {
            if (!el[key]) {
              areAllFieldsFilled = false;
            }
          }
        });
      } else {
        Object.keys(el).forEach((key) => {
          if (!el[key] && key !== "operating") {
            areAllFieldsFilled = false;
          }
        });
      }
    });

    if (workHistoryData[0].to && workHistoryData[0].from) {
      let oldestDate = moment(workHistoryData[0].to).format("YYYY-MM-DD");
      let earliestDate = moment(workHistoryData[0].from).format("YYYY-MM-DD");

      workHistoryData.forEach((el, i) => {
        const from = el.from ? moment(el.from).format("YYYY-MM-DD") : null;
        const to = el.to ? moment(el.to).format("YYYY-MM-DD") : null;

        // Validation if 'from' date is before 'to' date validation
        if (from && to && moment(to).isBefore(from)) {
          const prev = validationMessages[i] ? validationMessages[i] : {};
          validationMessages[i] = {
            ...prev,
            toAfterFromDate: "From date can not be after to date",
          };
        }

        if (from && moment(from).isBefore(oldestDate)) {
          oldestDate = from;
        }

        if (to && moment(to).isAfter(earliestDate)) {
          earliestDate = to;
        }
      });

      // Validation whole time (min 5 years /(- 28 days))
      if (oldestDate && earliestDate) {
        const r = moment(earliestDate).diff(moment(oldestDate), "years", true);

        if (!(r >= 4.924731182795699)) {
          setFiveYearsErrorMessage(
            "Please ensure the work history you have entered covers the last 5 years."
          );
        } else {
          setFiveYearsErrorMessage("");
        }
      }

      // Validation difference in time between jobs (max 28 days)
      for (let i = 0; workHistoryData.length - 1; i += 1) {
        if (i === workHistoryData.length - 1) {
          break;
        }
        if (
          workHistoryData[i + 1].from &&
          workHistoryData[i + 1].to &&
          workHistoryData[i].from &&
          workHistoryData[i].to
        ) {
          const start = moment(workHistoryData[i + 1].to, "YYYY/MM/DD");
          const end = moment(workHistoryData[i].from, "YYYY/MM/DD");
          const r = moment(end).diff(moment(start), "days", true);

          const startDESC = moment(workHistoryData[i].to, "YYYY/MM/DD");
          const endDESC = moment(workHistoryData[i + 1].from, "YYYY/MM/DD");
          const rDESC = moment(endDESC).diff(moment(startDESC), "days", true);

          if (r > 28 || rDESC > 28) {
            const prev = validationMessages[i + 1]
              ? validationMessages[i + 1]
              : {};
            validationMessages[i + 1] = {
              ...prev,
              tooBigGap:
                "You have a gap of more than 28 days in comparison with the last job you entered, please amend as we can not accept a gap of more than 28 days without details of a character reference to contact.",
              keepOrder:
                "Please ensure your work history is in chronological order so we can validate your dates.",
            };
          }
        }
      }
    }

    validationMessages.forEach((el) => {
      Object.keys(el).forEach((key) => {
        if (el[key] && Object.keys(el[key]).length > 0) {
          areErrorMessagesEmpty = false;
        }
      });
    });

    setValidationErrorMessage(validationMessages);

    if (areAllFieldsFilled && areErrorMessagesEmpty) {
      setShouldDisable(false);
    } else {
      setShouldDisable(true);
    }
  }, [shouldDisable, workHistoryData, fiveYearsErrorMessage]);

  const initialState = {
    fiveYear: {
      htmlObj: (
        <div>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            Candidates are required to supply their full checkable employment
            history for the last 5 years or, since reaching the age of 16,
            whichever is the shorter period. For example: Education, Training,
            Employment / Unemployment. One character referee* must be provided
            to support your 5-year checkable employment history. If you are
            aware of any reason why it may not be possible to obtain a
            particular reference, i.e. the employer is no longer in business,
            please give details in the space provided and provide an alternative
            referee to vouch for you (they must be a character referee, known to
            you socially for at least 5 years). We also require a reference(s)
            with full details of any gaps in employment/education of 28 days or
            more covering the last five years.{" "}
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            A full employment history can be obtained by contacting HMRC
            directly at{" "}
            <a href="https://gov.uk" target="_blank" rel="noopener noreferrer">
              www.gov.uk
            </a>
          </p>
          <b>
            PLEASE NOTE: We will not approach employers for references until a
            formal job offer is made.
          </b>
          <br />
          <br />
          <p style={{ color: "red", fontSize: "14px" }}>
            *Referees should not be related to you nor co-habit with you.
          </p>
        </div>
      ),
    },
    candidateDetails: {
      htmlObj: <HorizontalLine text="Candidate Details" />,
    },
    lastName: {
      title: "Last Name:",
      value: getVal("lastName"),
      mandatory: true,
    },
    firstName: {
      title: "First Name:",
      value: getVal("firstName"),
      mandatory: true,
    },
    middleName: {
      title: "Middle Name (s):",
      value: getVal("middleName"),
    },
    knownAs: {
      title: "Also known as:",
      value: getVal("knownAs"),
    },
    nationalInsuranceNo: {
      title: "National Insurance/ PPS No:",
      value: getVal("nationalInsuranceNo"),
      mandatory: true,
    },
    emailAddress: {
      title: "Email Address:",
      value: getVal("emailAddress"),
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSave = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    const ninObj = fields.nationalInsuranceNo.value
      .split("")
      .slice(0, 9)
      .reduce((acc, v, i) => ({ ...acc, [`nin${i + 1}`]: v }), {});

    const dateFormatted = moment().format("DDMMYYYY");
    const dateIntoObject = dateFormatted
      .split("")
      .splice(0, 8)
      .reduce((acc, v, i) => ({ ...acc, [`date${i + 1}`]: v }), {});

    postSwissportFormFunc("fiveYearHistory", {
      ...fieldValuesPayload,
      workHistoryData,
      travelData,
      ...ninObj,
      ...dateIntoObject,
    });

    history.push("/profile/edit/swissport-onboarding");
  };

  const setValue = (value, key, i) => {
    const mappedHistoryData = workHistoryData.map((el, index) => {
      if (key === "operating" && i === index) {
        return { ...el, [key]: !el.operating };
      }
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setWorkHistoryData(mappedHistoryData);
  };

  const setTravelInfo = (value, key) => {
    setTravelData({ ...travelData, [key]: value });
  };

  const removeLast = () => {
    const newArr = [...workHistoryData];
    newArr.splice(newArr.length - 1);
    setWorkHistoryData(newArr);
  };

  const inputStyle = { width: "20px", height: "20px", marginRight: "5px" };

  const showAstrix = (el) => {
    if (el.type === "Gap") {
      return "";
    }
    return "*";
  };

  const customHtml = (
    <Fragment>
      {workHistoryData.map((el, i) => (
        <Fragment key={i}>
          <HorizontalLine text="Employment History" desc={`Part ${i + 1}`} />
          <form>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                margin: "1rem 0",
              }}
              onChange={(e) => setValue(e.target.value, "type", i)}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  style={inputStyle}
                  type="radio"
                  value="Employed"
                  name="type"
                  checked={el.type === "Employed"}
                />{" "}
                Employed
              </div>
              <div
                style={{
                  padding: "5px 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  style={inputStyle}
                  type="radio"
                  value="Education"
                  name="type"
                  checked={el.type === "Education"}
                />{" "}
                Education
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  style={inputStyle}
                  type="radio"
                  value="Benefit Office"
                  name="type"
                  checked={el.type === "Benefit Office"}
                />{" "}
                Benefit Office
              </div>
              <div
                style={{
                  padding: "5px 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  style={inputStyle}
                  type="radio"
                  value="Gap"
                  name="type"
                  checked={el.type === "Gap"}
                />{" "}
                Gap
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  style={inputStyle}
                  type="radio"
                  value="Other"
                  name="type"
                  checked={el.type === "Other"}
                />{" "}
                Other
              </div>
            </div>
            <label className="grey-text">Exact Date From*</label>
            <input
              type="date"
              value={el.from}
              onChange={(e) => setValue(e.target.value, "from", i)}
              required
              className="form-control"
            />
            <label className="grey-text">Exact Date To*</label>
            <input
              value={el.to}
              onChange={(e) => setValue(e.target.value, "to", i)}
              required
              type="date"
              className="form-control"
            />
            <p style={{ color: "red", fontSize: "13px" }}>
              {validationErrorMessage[i] &&
                validationErrorMessage[i].toAfterFromDate}
            </p>
            <p style={{ color: "red", fontSize: "13px" }}>
              {validationErrorMessage[i] && validationErrorMessage[i].tooBigGap}
            </p>
            <p style={{ color: "red", fontSize: "13px" }}>
              {validationErrorMessage[i] && validationErrorMessage[i].keepOrder}
            </p>
            <label className="grey-text">
              Full Name of Organisation or Referee{showAstrix(el)}
            </label>
            <input
              required={el.type !== "Gap"}
              onChange={(e) => setValue(e.target.value, "company", i)}
              value={el.company}
              className="form-control"
            />
            <label className="grey-text">
              Postal Address of Organisation or Referee{showAstrix(el)}
            </label>
            <input
              onChange={(e) => setValue(e.target.value, "address", i)}
              value={el.address}
              required={el.type !== "Gap"}
              className="form-control"
            />
            <label className="grey-text">
              Email Address of Organisation or Referee{showAstrix(el)}
            </label>
            <input
              onChange={(e) => setValue(e.target.value, "email", i)}
              value={el.email}
              required={el.type !== "Gap"}
              className="form-control"
            />
            <div
              style={{
                display: "flex",
                padding: "1rem 0",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <label className="grey-text">
                If appropriate, please tick this box if the business you listed
                above is still trading.
              </label>
              <input
                type="checkbox"
                onChange={(e) => setValue(e.target.value, "operating", i)}
                value={el.operating}
                checked={el.operating}
                style={{ height: "24px", width: "24px" }}
              />
            </div>
            <label className="grey-text">
              Reason for leaving{showAstrix(el)}
            </label>
            <textarea
              onChange={(e) => setValue(e.target.value, "reason", i)}
              value={el.reason}
              required={el.type !== "Gap"}
              className="form-control"
            />
          </form>
        </Fragment>
      ))}
      <div>
        <p style={{ color: "orange", fontSize: "14px" }}>
          {fiveYearsErrorMessage && fiveYearsErrorMessage}
        </p>
        {
          <button
            disabled={workHistoryData.length === 1}
            onClick={removeLast}
            className="btn btn-secondary my-2"
          >
            Remove Last
          </button>
        }
        <button
          onClick={() =>
            setWorkHistoryData([
              ...workHistoryData,
              {
                from: "",
                to: "",
                company: "",
                address: "",
                email: "",
                reason: "",
                operating: false,
              },
            ])
          }
          className="btn btn-secondary m-2 "
        >
          {" "}
          Add More{" "}
        </button>
      </div>
      <HorizontalLine text="Overseas Visits" />
      <p className="my-2">
        Please use the space below to detail overseas visits lasting a period of
        6 months or more.
      </p>
      <label style={{ marginTop: "15px" }} className="grey-text">
        Exact Date From
      </label>
      <input
        type="date"
        value={travelData.fromTravel1}
        onChange={(e) => setTravelInfo(e.target.value, "fromTravel1")}
        className="form-control"
      />
      <label style={{ marginTop: "10px" }} className="grey-text">
        Exact Date To
      </label>
      <input
        type="date"
        value={travelData.toTravel1}
        onChange={(e) => setTravelInfo(e.target.value, "toTravel1")}
        className="form-control"
      />
      <label style={{ marginTop: "10px" }} className="grey-text">
        Country Visited
      </label>
      <input
        value={travelData.countryVisited1}
        onChange={(e) => setTravelInfo(e.target.value, "countryVisited1")}
        className="form-control"
      />
      <label style={{ marginTop: "15px" }} className="grey-text">
        Exact Date From
      </label>
      <input
        type="date"
        value={travelData.fromTravel2}
        onChange={(e) => setTravelInfo(e.target.value, "fromTravel2")}
        className="form-control"
      />
      <label style={{ marginTop: "10px" }} className="grey-text">
        Exact Date To
      </label>
      <input
        type="date"
        value={travelData.toTravel2}
        onChange={(e) => setTravelInfo(e.target.value, "toTravel2")}
        className="form-control"
      />
      <label style={{ marginTop: "10px" }} className="grey-text">
        Country Visited
      </label>
      <input
        style={{ marginBottom: "20px" }}
        value={travelData.countryVisited2}
        onChange={(e) => setTravelInfo(e.target.value, "countryVisited2")}
        className="form-control"
      />
      <HorizontalLine text="Declaration" />
      <p style={{ textAlign: "justify", textJustify: "interWord" }}>
        The information contained in this form shall be protected in accordance
        with the principles of prevailing data protection regulation and will
        not be divulged to any third party unless the information is required
        for ID pass application purposes by a nominated referencing company or
        the relevant airport authority. We also reserve the right to share
        information with relevant authorities to prevent fraud or a criminal
        act.
      </p>
      <p style={{ textAlign: "justify", textJustify: "interWord" }}>
        I confirm that to the best of my knowledge and belief the information
        given above is complete and accurate. I understand that false or
        inaccurate information may disqualify me from employment, or make me
        liable to summary dismissal, and in appropriate cases, criminal charges.
      </p>
      <p style={{ textAlign: "justify", textJustify: "interWord" }}>
        I authorise Swissport to approach former employers, educational
        establishments, government agencies and personal referees for
        verification of the information supplied. I understand that to give
        false information may also be considered a criminal offence under the
        Aviation Maritime and Security Act 1990.
      </p>
      <div
        style={{
          display: "flex",
          padding: "1rem 0",
          alignItems: "center",
          width: "100%",
        }}
      >
        <input
          type="checkbox"
          required
          onChange={() => setDeclaration(!declaration5YCH)}
          value={declaration5YCH}
          style={{ height: "20px", width: "20px", marginRight: "10px" }}
        />
        <div>I understand and agree to the declaration above.*</div>
      </div>
    </Fragment>
  );

  return (
    <Fragment>
      <FormCreator
        formTitle={"5 Year Checkable Employment History"}
        description="Please read this form carefully"
        fields={fields}
        setField={setField}
        handleCancel={() => history.push("/profile/edit/swissport-onboarding")}
        onboardingBranch={"swissport"}
        customHtml={customHtml}
        handleSave={handleSave}
        disableSave={
          shouldDisable || !declaration5YCH || !!fiveYearsErrorMessage
        }
        isCustomSaveButton={true}
      />
    </Fragment>
  );
};
FiveYearHistory.propTypes = {
  appData: any,
  postSwissportFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postSwissportFormFunc: postSwissportForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FiveYearHistory);
